export default {
  alignment: 'Zarovnanie',
};
